module.exports = __webpack_public_path__ + "static/media/armadillo-hotel.43bf7041.jpg";